export function startMain() {
  jQuery(function($) {
    "use strict";
    window.addEventListener(
      "scroll",
      function() {
        //When scroll change, you save it on localStorage.
        this.sessionStorage.setItem("scrollPosition", window.scrollY);
      },
      false
    );
    window.addEventListener(
      "load",
      function() {
        if (localStorage.getItem("scrollPosition") !== null)
          window.scrollTo(0, this.sessionStorage.getItem("scrollPosition"));
      },
      false
    );

    $(document).ready(function() {
      var iOS = false,
        p = navigator.platform;
      if (p === "iPad" || p === "iPhone" || p === "iPod") {
        iOS = true;
      }
      if (iOS === true) {
        $(".iparaxify").removeClass("paraxify");
      }
    });

    $(".accordion-toggle").on("click", function() {
      $(this)
        .closest(".panel-group")
        .children()
        .each(function() {
          $(this)
            .find(">.panel-heading")
            .removeClass("active");
        });
      $(this)
        .closest(".panel-heading")
        .toggleClass("active");
    });

    var form = $("#main-contact-form");
    form.submit(function(event) {
      event.preventDefault();
      var form_status = $('<div class="form_status"></div>');
      $.ajax({
        url: $(this).attr("action"),
        beforeSend: function() {
          form.prepend(
            form_status
              .html(
                '<p><i class="fa fa-spinner fa-spin"></i> Email is sending...</p>'
              )
              .fadeIn()
          );
        }
      }).done(function() {
        form_status
          .html(
            '<p class="text-success">Thank you for contact us. As early as possible  we will contact you</p>'
          )
          .delay(3000)
          .fadeOut();
      });
    });
  });
}
